import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "@/lib/query-keys";
import { stockService } from "@/services/stock";

export function useStockReasons(params?: {
  direction?: string;
  is_active?: boolean;
}) {
  return useQuery({
    queryKey: queryKeys.stocks.reasons(params as Record<string, unknown>),
    queryFn: () => stockService.reasons(params),
  });
}
